import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { PREMIO_ANNUALE } from "../constants";

const SuccessPage = ({ numeroPreventivo, formData, onNewQuote, onGoHome }) => {
  return (
    <Box sx={{ width: "100%", maxWidth: 800, mx: "auto" }}>
      {/* Header Verde Successo */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #4caf50, #66bb6a)",
          color: "white",
          py: 5,
          px: 4,
          textAlign: "center",
          borderRadius: 3,
          mb: 4,
          boxShadow: "0 8px 32px rgba(76, 175, 80, 0.3)",
        }}
      >
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto",
            mb: 2,
          }}
        >
          <CheckCircleOutlineRoundedIcon sx={{ fontSize: 50 }} />
        </Box>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Preventivo Salvato con Successo!
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9 }}>
          Il tuo preventivo è stato creato e salvato
        </Typography>
      </Box>

      {/* Numero Preventivo e Premio Annuale in riga */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              border: (theme) =>
                `2px solid ${
                  theme.palette.mode === "light" ? "#ffb74d" : "#ff9800"
                }`,
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              height: "100%",
              backgroundColor: (theme) =>
                theme.palette.mode === "light"
                  ? "#fffbf0"
                  : "rgba(255, 152, 0, 0.05)",
            }}
          >
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Numero Preventivo
            </Typography>
            <Typography variant="h6" fontWeight={700}>
              {numeroPreventivo}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              background: "linear-gradient(135deg, #f59e0b, #fbbf24)",
              color: "white",
              borderRadius: 2,
              p: 3,
              textAlign: "center",
              height: "100%",
            }}
          >
            <Typography variant="body2" sx={{ opacity: 0.9, mb: 1 }}>
              Premio Annuale
            </Typography>
            <Typography variant="h3" fontWeight={700}>
              €{PREMIO_ANNUALE}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Dati Contraente */}
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 2,
          p: 3,
          mb: 3,
        }}
      >
        <Typography variant="h6" fontWeight={600} gutterBottom>
          Dati Contraente
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">
              Nome:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight={600} textAlign="right">
              {formData.nome} {formData.cognome}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">
              Email:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight={600} textAlign="right">
              {formData.email}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">
              Telefono:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight={600} textAlign="right">
              {formData.telefono}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" color="text.secondary">
              Valido fino al:
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" fontWeight={600} textAlign="right">
              {new Date(
                new Date().setMonth(new Date().getMonth() + 1),
              ).toLocaleDateString("it-IT", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {/* Prossimi Passi */}
      <Box
        sx={{
          border: (theme) =>
            `2px solid ${
              theme.palette.mode === "light" ? "#ffb74d" : "#ff9800"
            }`,
          borderRadius: 2,
          p: 3,
          mb: 3,
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? "#fff8e1"
              : "rgba(255, 152, 0, 0.05)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <EmailRoundedIcon sx={{ color: "#1976d2", fontSize: 24 }} />
          <Typography variant="h6" fontWeight={600}>
            Prossimi Passi
          </Typography>
        </Box>
        <Box sx={{ pl: 2 }}>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            1. Riceverai una email di conferma all'indirizzo {formData.email}
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            2. Un nostro consulente ti contatterà per finalizzare la
            sottoscrizione
          </Typography>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            3. Potrai procedere al pagamento e attivare la tua polizza
          </Typography>
          <Typography variant="body2">
            4. Riceverai la documentazione completa via email
          </Typography>
        </Box>
      </Box>

      {/* Pulsanti */}
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="outlined"
            startIcon={<HomeRoundedIcon />}
            onClick={onGoHome}
            sx={{
              borderColor: "#1976d2",
              color: "#1976d2",
              "&:hover": {
                borderColor: "#1565c0",
                backgroundColor: "rgba(25, 118, 210, 0.08)",
              },
            }}
          >
            Torna alla Home
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button
            fullWidth
            variant="contained"
            startIcon={<AddCircleOutlineRoundedIcon />}
            onClick={onNewQuote}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": {
                backgroundColor: "#1565c0",
              },
            }}
          >
            Nuovo Preventivo
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SuccessPage;
